
// 分期支付代码
document.addEventListener('DOMContentLoaded', function() {
  // 定义一个函数来更新 PayPal 消息
  function updatePayPalMessage(price) {
    const ppMessage = document.querySelector('[data-pp-message]');
    if (ppMessage && window.PayPalSDK) {
      // 设置新的金额属性
      ppMessage.setAttribute('data-pp-amount', price);
      
      // 告诉 PayPal SDK 刷新消息
      window.PayPalSDK.Messages({
        amount: price,
        placement: 'product'
      }).render(ppMessage);
    }
  }

  // 监听 Shopify 默认的变体变更事件 (不同主题可能略有不同)
  // 方法 1: 监听 URL 变化 (最通用，适用于大多数 2.0 主题)
  let lastUrl = location.href; 
  new MutationObserver(() => {
    const url = location.href;
    if (url !== lastUrl) {
      lastUrl = url;
      // 延迟一点时间等待 DOM 更新价格
      setTimeout(() => {
        // 获取当前页面显示的最新价格（你需要根据你的主题找到价格的 CSS Selector）
        // 这里假设价格元素有 .price-item--regular 这个类
        const priceElement = document.querySelector('.price-item--regular'); 
        if(priceElement) {
            // 清理价格字符串，只保留数字和点
            let priceText = priceElement.innerText.replace(/[^0-9.]/g, '');
            updatePayPalMessage(parseFloat(priceText));
        }
      }, 500);
    }
  }).observe(document, {subtree: true, childList: true});
  
  // 方法 2: 监听自定义事件 (如果你知道主题触发的事件名，例如 'variant:change')
  // document.addEventListener('variant:change', function(event) {
  //   updatePayPalMessage(event.detail.variant.price / 100);
  // });
});